import { useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { useCountryStates } from './useCountryStates'

interface IUseCountryStateSourceParams {
  countryName: string
  state?: string
  isStatic?: boolean
}

const ASIAN_REG = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/u

export const useCountryStateSource = ({
  countryName,
  state,
  isStatic,
}: IUseCountryStateSourceParams) => {
  const key = 'Basic'
  const { states, statesWithLocal } = useCountryStates(countryName, key)

  const isLocalState = state && ASIAN_REG.test(state)

  const crudParams = useMemo(
    () => ({
      fetcher: new Static(isLocalState ? statesWithLocal : states),
      keyField: 'key',
    }),
    [isLocalState, states, statesWithLocal]
  )

  const crudStaticParams = useMemo(
    () => ({
      ...crudParams,
      defaultPaging: {
        page: 0,
        pageSize: states.length,
      },
      defaultSort: {
        field: 'key',
        dir: 'asc' as const,
      },
    }),
    [crudParams, states.length]
  )

  const source = useMemo(
    () => (isStatic ? new Crud(crudStaticParams) : new Crud(crudParams)),
    [crudParams, crudStaticParams, isStatic]
  )

  return source
}
